import { css } from '@emotion/react';
import React, { memo } from 'react';
import useMedia from '~/hooks/useMedia';
import { WHITE, globalGrey } from '~/modules/AppLayout/Colors';
import { ai, jc, flex } from '~/modules/AppLayout/FlexGridCss';
import { fontWeight600 } from '~/css/font';
import CustomizedRadarChart from '~/modules/tradeSheet/shared/CustomizedRadarChart';
import CustomizedRadarText from '~/modules/tradeSheet/shared/CustomizedRadarText';
import { useTradingSummaryState } from '~/modules/tradeSheet/tradingSummary/useTradingSummaryState';
import ToolTipDirections from '~/modules/tradeSheet/tradingSummary/ToolTipDirections';
const sectionItemCss = css `
  border-radius: 8px;
  background: ${WHITE};
`;
const TradingStrengthOverall = memo(function TradingStrengthOverall(props) {
    const { state } = useTradingSummaryState.useContainer();
    const { analysisDetails } = state;
    const { isPhone } = useMedia();
    return (<div css={flex.v.default}>
      <p css={css `
          background: #00aab6;
          color: #ffffff;
          border-radius: 8px;
          font-size: 18px;
          padding: 4px 12px;
          align-self: flex-start;
        `}>
        交易雷達圖
      </p>
      <div css={css `
          width: 100%;
          ${sectionItemCss};
          ${isPhone ? flex.v.allCenter : flex.h.default}
          ${jc.spaceBetween};
          ${isPhone ? ai.center : ai.flexStart};
        `}>
        <CustomizedRadarText data={analysisDetails}/>
        <div css={css `
            ${flex.v.allCenter};
            ${fontWeight600};
            width: 450px;
            height: 375px;
          `}>
          <CustomizedRadarChart details={analysisDetails} showRating={true}/>
          <p css={css `
              ${flex.h.default};
              color: ${globalGrey.g500};
              ${fontWeight600};
              font-size: 16px;
              margin: 0;
            `}>
            ＊灰色為期顧交易數值分析 &nbsp;
            <ToolTipDirections />
          </p>
        </div>
      </div>
    </div>);
});
export default TradingStrengthOverall;
